//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 
import UMUM         from "../../../library/umum"        ;
import WILAYAH      from "../../../library/getWilayah"  ;
import CHART        from '../../../library/chart';

export default {
  data() {
    return {
      form : {
        id : '',
        masterPendidikan : '',
        des_kel : this.$store.state.ID_DES_KEL,
        jumlah : '',
        tahun : '2020',
        createdAt : '',
      },
     
      list_data : [],

      page_limit: 1000,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,
      cek_load_data:true,

      UMUM: UMUM
    };
  },
  methods: {
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_DATA_PENDIDIKAN + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
        //   authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              tahun: this.form.tahun,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
            //   console.log(res_data);
      });
    },

    selectData : function(data){
        console.log('aaaaa');
        this.form.id = data.id;
        this.form.jumlah = data.jumlah;
        this.form.masterPendidikan = data.masterPendidikan;
        this.form.des_kel = data.des_kel;
        this.form.jumlah = data.jumlah;
        this.form.tahun = data.tahun;

    },
    // Data_Pendidikan
    chartDataPendidikan : async function(){
      var body = this.form
      var dataArray = await CHART.postData(this.$store.state.url.URL_CNT_DESA_DATA_PENDIDIKAN, 'chart_data_pendidikan', body);
      console.log(dataArray)
      CHART.BarChart('Data_Pendidikan', 'Data Pendidikan', 'Data Pendidikan', dataArray.uraian, dataArray.jumlah, 'Orang')
                                    // id,             title,               subtitle,       categories,    data
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.chartDataPendidikan()
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


        // fetching : async function(){
        //   var ss = await FETCHING.getJenisUsaha();
        //   console.log(ss)
        // }




    // ====================================== PAGINATE ====================================
  },
  mounted() {
      const d = new Date();
    this.form.tahun = d.getFullYear();
    console.log(this.form.tahun)
    this.form.des_kel = this.$store.state.ID_DES_KEL

    
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.cari_data();
    this.form.tahun = UMUM.getTahun();
    WILAYAH.getListDesKelFull();
  }
};
